import { SyntheticEvent } from 'react';
import { range } from 'd3-array';
import { getYear } from 'date-fns';

import NO_IAMGE from '@assets/image/empty.png';

export const onImageError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = NO_IAMGE;
};

// 이메일 정규식
export const isEmail = (email: string) => {
    const emailRegex =
        /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return emailRegex.test(email);
};
// url 정규식
export const isUrl = (url: string) => {
    const urlRegex = /^(http|https):\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/;
    return urlRegex.test(url);
};
// 휴대폰 번호 Hyphen 삽입
export const autoHyphen = (phoneNumber: string) => {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
        3,
        7
    )}-${phoneNumber.slice(7, 11)}`;
};

// 숫자만 입력 가능
export const onlyNumber = (text: string) => {
    return text.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
};

// 영문 대소문자 포함 여부
export const isRequiredChars = (password: string) => {
    let reg = /(?=.*?[a-z])(?=.*?[A-Z])/;
    return reg.test(password);
};

// 숫자 특수문자 포함 여부
export const isNumericSpecialChars = (password: string) => {
    let reg = /(?=.*?[0-9])(?=.*?[#?!@$%^&*-])/;
    return reg.test(password);
};

// 문자열 길이 8~16자리 체크 여부
export const isRequiredLength = (password: string) => {
    let reg = /^.{8,16}$/;
    return reg.test(password);
};

// 반복되는 문자 체크 여부 - 반복되면 true
export const isRepeatedChars = (password: string) => {
    let reg = /(.)\1+/;
    return reg.test(password);
};

/**
 * todo 년도 구하기
 * @param {string} format todo 날짜 포맷
 * @param {number} start todo 시작년도
 * @param {number} end todo 종료년도
 */
export const getYearOption = (
    format?: string,
    start?: number,
    end?: number
) => {
    let years: string[] | number[] = range(
        start || getYear(new Date()),
        end || getYear(new Date()) + 10,
        1
    ).reverse();

    switch (format) {
        case 'YYYY년':
            return years.map((year) => `${year}년`);
        default:
            return years;
    }
};
